import Bag from '@phoenix/components/Bag';
import createVueApp from '@phoenix/createVueApp';
import ProductSpecsTabs from '@maison/components/product/ProductSpecsTabs.vue';
import WishlistButton from '@maison/components/wishlist/WishlistButton.vue';

document.querySelectorAll('.phoenix-product-specs-tabs').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('ProductSpecsTabs', ProductSpecsTabs);
  app.component('WishlistButton', WishlistButton);
  app.mount(el);
});

Object.assign(window, {
  Bag,
});
